<template>
        <v-container
        class="scroll-y"
        fluid
        >
        <v-row
        align="center"
        justify="center"
        >
        <v-col cols="10" md="10">
          <v-card class="ml-20 mr-20">
            <v-app-bar
            dark
            color="#2C3A47"
            >
            <v-btn icon>
              <v-icon>mdi-integrated-circuit-chip</v-icon>
            </v-btn>
          <v-toolbar-title>Base</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" persistent max-width="800px">
            <template v-slot:activator="{ on }">
                <v-btn color="red" v-on="on" outlined="">
                  <v-icon left>add</v-icon> ADD
                </v-btn>
            </template>
              <v-card>
                <v-form @submit.prevent="saveBase" ref="baseData" lazy-validation enctype="multipart/form-data" autocomplete="off">
                  <v-card-title>
                    <span class="headline">Base</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                      <v-flex xs12 sm12 md12>
                        <v-text-field label="Base ID*"  v-model="baseData.baseId" color="#2C3A47"></v-text-field>
                        <v-text-field label="Label name*"  v-model="baseData.labelName" color="#2C3A47"></v-text-field>
                        <v-select 
                          :items="serialNumber"
                          item-value="_id"
                          item-text="serialNumber"
                          v-model="baseData.serialNumber"
                          label="Serial number*">
                          </v-select>
                      </v-flex>
                 
                    </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#2C3A47" dark @click="close" outlined small>
                      <v-icon left>exit_to_app</v-icon> Close
                    </v-btn>
                    <v-btn color="light-green darken-4" dark type="submit" outlined small>
                      <v-icon left>save</v-icon> {{saveDialog}}
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
          </v-dialog>
            </v-app-bar>
            <v-container>
              <v-card class="mx-auto elevation-19">
                <v-card-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                  color="#2C3A47"
                  >
                  </v-text-field>
                </v-card-title>
        <v-data-table
        item-key="id"
        :headers="headers"
        :items="base"
        :search="search"
        
        >
         <template v-slot:[`item.updatedAt`]="{ item }">
      {{ formatDate(item.updatedAt) }}
    </template>
        <template v-slot:[`item.actions`]="{item}">
          <v-btn color="success" class="mx-2" fab x-small @click="editBase(item)" outlined>
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn color="pink" fab x-small @click="deleteBase(item._id)" outlined>
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </template>
        <template v-slot:no-results>
            <v-alert :value="true" color="pink" icon="warning" dark>
              Your Search {{search}} does not exist.
            </v-alert>
        </template>

        </v-data-table>
              </v-card>
            </v-container>
          </v-card>
          <v-snackbar
          v-model="snackbar"
          top
          right
          :color="color"
          >
          {{text}}
          <v-btn
          color="black"
          text
          @click="snackbar = false"
          >
          Dissmiss
          </v-btn>

          </v-snackbar>
        </v-col>

        </v-row>

        </v-container>
  
  
  
</template>
<script>
import axios from "axios";
import moment from 'moment';
export default {
  props:{
    source: String
  },
  data: () => ({
    mini: false,
    dialog:false,
    fab: false,
    search:'',
    snackbar: false,
    text:'',
    color:'',
    base:[],
    serialNumber:[],
    headers: [
        {text: 'Base ID', value: 'baseId', sortable: true},
        {text: 'Label Name', value: 'labelName', sortable: true},
        {text: 'Serial Number', value: 'serialNumber.serialNumber', sortable: true},
        {text: 'Modified By', value: 'modifiedBy', sortable: true},
        {text: 'Last Modified Date', value: 'updatedAt', sortable: true},
        {text: 'Action', value: 'actions', sortable: false, width: '180px'},
    ],
    baseData: {
      baseId: '',
      labelName: '',
      serialNumber:{
          serialNumber: ''
      },
      modifiedBy: ''
    },
    default: {
      baseId: '',
      labelName: '',
      serialNumber:{
          serialNumber:''
      },
      modifiedBy: ''
    },
    editedIndex: -1,
  }),
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  computed: {
    saveDialog() {
      return this.editedIndex === -1 ? 'Save' : 'Edit'
    }
  },
  mounted() {
    this.loadsBase();
    this.loadsSerialNumber();
  },
  methods: {
    formatDate(value) {
      return moment(value).format("D MMM YYYY, h:mm:ss a")
  },
loadsBase: async function(){
  let apiURL = process.env.VUE_APP_API + "/api/base-all";
  axios.get(apiURL).then(res => {
    this.base = res.data;
  }).catch(error => {
    console.log(error)
  });
},

loadsSerialNumber: async function(){
  let apiURL = process.env.VUE_APP_API + "/api/serial-number-available";
  axios.get(apiURL).then(res => {
    this.serialNumber = res.data;
  }).catch(error => {
    console.log(error)
  });
},

    onScroll (e) {
      if(typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.fab = top > 20
    },
    toTop(){
      this.$vuetify.goTo(0)
    },
    close(){
      this.dialog = false
      setTimeout(()=>{
        this.baseData = Object.assign({}, this.default)
        this.editedIndex = -1
      }, 300)
    },
    saveBase: async function(){
        if(this.editedIndex > -1) {
         this.updateBase();
        }else {
          this.createBase();
        }
    },
    createBase(){
      let apiURL = process.env.VUE_APP_API + "/api/create-base";
        axios.post(apiURL, {
        baseId: this.baseData.baseId ,
        labelName: this.baseData.labelName,
        serialNumber: this.baseData.serialNumber,
        modifiedBy: this.$keycloak.tokenParsed.given_name
        }).then(() => {
          this.close();
          this.loadsBase();
          this.loadsSerialNumber();
          this.color = 'success'
          this.text ='Base has been successfully saved.'
          this.snackbar = true;
        }).catch(error => {
          console.log(error)
        });
    },
    editBase(item) {
      this.editedIndex = this.base.indexOf(item)
      this.baseData = Object.assign({}, item)
      this.dialog = true
    },
    updateBase(){
      let apiURL = process.env.VUE_APP_API + `/api/update-base/${this.baseData._id}`;
      axios.post(apiURL, {
        baseId: this.baseData.baseId ,
        labelName: this.baseData.labelName,
        serialNumber: this.baseData.serialNumber,
        modifiedBy: this.$keycloak.tokenParsed.given_name
        }).then((res) => {
        console.log(res)
        this.close();
        this.loadsBase();
        this.loadsSerialNumber();
        this.color ='info'
        this.text = 'Base has been modified.'
        this.snackbar = true;
      }).catch(error => {
        console.log(error)
        console.log(this.$route.params.id)
      })
    },
     deleteBase(id){
  this.$swal({
                    title: 'Are you sure?',
                    text: "You will not be able to go back",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#00b894',
                    cancelButtonColor: '#d63031',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    }).then((result) => {
                        // Send request to the server
                         if (result.value) {
                               try {
                let apiURL = process.env.VUE_APP_API + `/api/delete-base/${id}`;
                let indexOfArrayItem = this.base.findIndex(i => i._id === id);
                axios.delete(apiURL).then(() => {
                        this.base.splice(indexOfArrayItem, 1);
                    }).catch(error => {
                        console.log(error)
                    });
                 this.$swal(
                         'Deleted!',
                         'Base has been deleted.',
                         'success'
                        )
                        //Notification error
                this.color = 'error'
                this.text = "Base has been deleted."
                this.snackbar = true;
                //Notification error
            }catch (error) {
             this.$swal("Failed!", "There was something wrong.", "warning");
            }
                         }
                    })
  
            },
  },

}
</script>